(() => {
  const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  const aliases = {
    description: 'description', productdescription: 'description',
    materialcare: 'care', materialsandcare: 'care', materialandcare: 'care', careinstructions: 'care', washandcare: 'care',
    shippingpolicy: 'shipping', shippingdelivery: 'shipping',
    returnrefundpolicy: 'returns', returnpolicy: 'returns', returnexchangepolicy: 'returns', returnsrefunds: 'returns',
    productdetails: 'details'
  };
  function init(info) {
    if (info.dataset.mashupSectionsReady) return;
    const description = info.querySelector('[id^="ProductDescription-"]');
    if (!description) return;
    info.dataset.mashupSectionsReady = 'true';
    const outer = description.closest('.product__accordion');
    const targets = { description: { wrapper: outer, body: description } };
    for (const wrapper of info.querySelectorAll('.product__accordion')) {
      if (description.contains(wrapper)) continue;
      const summary = wrapper.querySelector(':scope > details > summary');
      const key = summary && aliases[normalize(summary.textContent)];
      if (key) targets[key] = { wrapper, body: wrapper.querySelector(':scope > details > .accordion__content') };
    }
    function target(key, label) {
      if (targets[key]) return targets[key];
      const wrapper = outer.cloneNode(true);
      wrapper.removeAttribute('data-shopify-editor-block');
      const details = wrapper.querySelector('details');
      details.removeAttribute('open');
      details.id = outer.querySelector('details').id + '-' + key;
      const summary = details.querySelector('summary');
      summary.removeAttribute('aria-expanded');
      summary.removeAttribute('aria-controls');
      summary.querySelector('h2').textContent = label;
      const body = wrapper.querySelector('.accordion__content');
      body.replaceChildren();
      body.id = description.id + '-' + key;
      outer.after(wrapper);
      return targets[key] = { wrapper, body };
    }
    const moved = new Set();
    function transfer(key, label, nodes) {
      const destination = target(key, label);
      if (!destination.body) return;
      if (!moved.has(key)) {
        destination.body.replaceChildren();
        moved.add(key);
      }
      destination.body.append(...nodes);
    }
    for (const details of Array.from(description.querySelectorAll('details')).reverse()) {
      const summary = details.querySelector(':scope > summary');
      const key = summary && aliases[normalize(summary.textContent)];
      if (!key) continue;
      const body = details.querySelector(':scope > .accordion__content, :scope > .mpc-accordion-content');
      const nodes = body ? Array.from(body.childNodes) : Array.from(details.childNodes).filter(n => n !== summary);
      if (key === 'description') {
        details.replaceWith(...nodes);
      } else {
        transfer(key, summary.textContent.trim(), nodes);
        const wrapper = details.parentElement;
        details.remove();
        if (wrapper !== description && !wrapper.textContent.trim() && !wrapper.querySelector('img,video')) wrapper.remove();
      }
    }
    for (const heading of Array.from(description.querySelectorAll('h1,h2,h3,h4,h5,h6'))) {
      const key = aliases[normalize(heading.textContent)];
      if (!key || key === 'description' || !description.contains(heading)) continue;
      const nodes = [];
      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && /^H[1-6]$/.test(next.tagName))) {
        nodes.push(next);
        next = next.nextSibling;
      }
      if (nodes.length) {
        transfer(key, heading.textContent.trim(), nodes);
        heading.remove();
      }
    }
    for (const p of Array.from(description.querySelectorAll('p'))) {
      const text = p.textContent.trim().replace(/^\*+/, '').trim();
      if (/^care\s+(?:tip|instructions)\s*:/i.test(text) && !p.querySelector('br')) {
        transfer('care', 'Material & Care', [p]);
      }
      if (/^product\s+code\s*[-:]/i.test(text)) {
        const destination = target('details', 'Product Details');
        if (!destination.body.querySelector('dl')) {
          const dl = document.createElement('dl');
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');
          dt.textContent = 'Product Code';
          dd.textContent = text.replace(/^product\s+code\s*[-:]\s*/i, '');
          dl.append(dt, dd);
          destination.body.append(dl);
        }
        p.remove();
      }
    }
    let previous = outer;
    for (const key of ['care', 'shipping', 'returns', 'details']) {
      if (!targets[key]) continue;
      previous.after(targets[key].wrapper);
      previous = targets[key].wrapper;
    }
    for (const item of Object.values(targets)) {
      const details = item.wrapper.querySelector(':scope > details');
      details.removeAttribute('open');
      const summary = details.querySelector(':scope > summary');
      if (summary.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', 'false');
    }
  }
  function scan(root) {
    root.querySelectorAll('[id^="ProductInfo-"]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
